export var isEvmBlockchain = function (blockchainMeta) { return blockchainMeta.type === 'EVM'; };
export var isCosmosBlockchain = function (blockchainMeta) { return blockchainMeta.type === 'COSMOS'; };
export var isSolanaBlockchain = function (blockchainMeta) { return blockchainMeta.type === 'SOLANA'; };
export var isTronBlockchain = function (blockchainMeta) { return blockchainMeta.type === 'TRON'; };
export var isTransferBlockchain = function (blockchainMeta) {
    return blockchainMeta.type === 'TRANSFER';
};
export var isStarknetBlockchain = function (blockchainMeta) {
    return blockchainMeta.type === 'STARKNET';
};
export var isTonBlockchain = function (blockchainMeta) { return blockchainMeta.type === 'TON'; };
export var evmBlockchains = function (blockchains) {
    return blockchains.filter(isEvmBlockchain);
};
export var solanaBlockchain = function (blockchains) {
    return blockchains.filter(isSolanaBlockchain);
};
export var starknetBlockchain = function (blockchains) {
    return blockchains.filter(isStarknetBlockchain);
};
export var tronBlockchain = function (blockchains) {
    return blockchains.filter(isTronBlockchain);
};
export var cosmosBlockchains = function (blockchains) {
    return blockchains.filter(isCosmosBlockchain);
};
export var transferBlockchains = function (blockchains) {
    return blockchains.filter(isTransferBlockchain);
};
export var tonBlockchain = function (blockchains) {
    return blockchains.filter(isTonBlockchain);
};
//# sourceMappingURL=type-gaurds.js.map